<template>
    <div class="body">
        <div class="top-box-top">
            <top />
        </div>
        <div class="bottom-box">
            <basecom />
            <div class="list">
                <div class="medical-list">
                    <agencylist
                    :row-class-name="tableRowClassName"
                    :header-cell-style="{ 
                    background:'#000',color:'#fff'}"
                    :tableData="this.agencylogic.agencyList()"
                    :tableHeader="this.agencylogic.listHeader()"
                    :lazyLoad="this.agencylogic.getChildAgencyList"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import basecom from "@/components/base";
import top from "@/components/top";
import agencylist from "@/components/listComponents/treeList";
export default {
    components: {
    basecom,
    agencylist,
    top
},
data() {
    return {
    };
},
mounted() {
},
methods: {
    tableRowClassName({row, rowIndex}) {
        if(rowIndex%2==1){
            return 'warning-row';
        }else{
            return 'success-row';
        }
    },
},
};
</script>